<ng-progress></ng-progress>
<app-header></app-header>
<div class="app-body">
  <app-sidebar></app-sidebar>
  <!-- Main content -->
  <main class="main">
    <!-- Breadcrumb -->
    <ol class="breadcrumb">
      <app-breadcrumbs></app-breadcrumbs>
    </ol>
    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div><!-- /.conainer-fluid -->
  </main>
  <app-aside></app-aside>
</div>
<!--<app-footer></app-footer>-->



// WEBPACK FOOTER //
// /builds/sggd-10899/troca-senha-frontend/frontend/src/app/shared/layout/containers/full-layout/full-layout.component.html